module.exports = __webpack_public_path__ + "static/media/green_animal_reptiles.88434c84.png";